import React, { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./style/ContactUs.css";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(
        "https://shalishaenterprise.com/backend/contact_us.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      const data = await response.json();

      if (response.ok && data.apiresponse?.code === "0000") {
        toast.success(data.apiresponse.message || "Message sent successfully!");
        setFormData({ name: "", email: "", phone: "", message: "" });

        // ✅ Redirect to thank you page after slight delay
        setTimeout(() => {window.location.href ="/backend/thank_you.php"; }, 2000);
      } else {
        toast.error(data.apiresponse?.message || "Failed to send message");
      }
    } catch (err) {
      toast.error("An error occurred. Please try again.");
      console.error("Form error:", err);
    }
  };
     
  return (
    <section className="contact-wrapper text-white">
      <ToastContainer />
      <div className="container-fluid px-5">
        <div className="row g-0 min-vh-100">
          {/* Left - Image */}
          <div className="col-lg-6 d-none d-lg-block">
            <div className="h-100 mt-5">
              <img
                src="/assets/contactshalisha.webp"
                alt="Contact"
                className="img-fluid h-50 w-100 object-fit-cover rounded"
                style={{ objectFit: "cover", height: "60%" }}
              />
            </div>
          </div>

          {/* Right - Form */}
          <div className="col-lg-6 d-flex align-items-center justify-content-center p-5 h-50">
            <div className="w-100 " style={{ maxWidth: "600px" }}>
              <p className="text-uppercase text-warning mb-1">Contact Us</p>
              <h2 className="fw-bold mb-4">Get In Touch</h2>

              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <input
                    type="text"
                    name="name"
                    className="form-control custom-input"
                    placeholder="Your Name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="mb-3">
                  <input
                    type="email"
                    name="email"
                    className="form-control custom-input"
                    placeholder="Your Email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="mb-3">
                  <input
                    type="tel"
                    name="phone"
                    className="form-control custom-input"
                    placeholder="Your Phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="mb-4">
                  <textarea
                    rows="4"
                    name="message"
                    className="form-control custom-input"
                    placeholder="Your Message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                  ></textarea>
                </div>
                <button
                  className="btn btn-light text-dark px-4 py-2 rounded-pill"
                  type="submit"
                >
                  Send Message
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactUs;
